/**
 * Component sizes to generate atomic classes.
 *
 * WARNING!!! `key` and `value` are required.
 * Other are used in iCMS
 */
const componentSize = [
    // default from atomic
    // ...atomic.component,
    // custom local
    { key: 'default', value: '48px', title: `Default (48px)` },
    { key: 'size-1', value: '40px', title: `Size 1 (40px)` },
    { key: 'size-2', value: '30px', title: `Size 1 (30px)` }
];
exports.componentSize = componentSize;
